var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1119 60.3524C39.4192 60.3524 42.6941 59.701 45.7496 58.4353C48.8051 57.1697 51.5815 55.3146 53.9201 52.976C56.2587 50.6374 58.1138 47.861 59.3794 44.8055C60.6451 41.75 61.2965 38.4751 61.2965 35.1678C61.2965 31.8605 60.6451 28.5856 59.3794 25.53C58.1138 22.4745 56.2587 19.6982 53.9201 17.3596C51.5815 15.021 48.8051 13.1659 45.7496 11.9002C42.6941 10.6346 39.4192 9.98315 36.1119 9.98315L36.1119 16.5784C38.5531 16.5784 40.9703 17.0592 43.2257 17.9934C45.4811 18.9276 47.5304 20.2969 49.2565 22.0231C50.9827 23.7493 52.352 25.7986 53.2862 28.0539C54.2204 30.3093 54.7013 32.7266 54.7013 35.1678C54.7013 37.609 54.2204 40.0263 53.2862 42.2816C52.352 44.537 50.9827 46.5863 49.2565 48.3125C47.5304 50.0386 45.4811 51.4079 43.2257 52.3421C40.9703 53.2763 38.5531 53.7572 36.1119 53.7572L36.1119 60.3524Z",
    fill: "url(#paint0_linear_740_22187)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 1.49858,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 1.49858,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 1.49858,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 1.49858,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 8.31597,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 8.31597,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 8.31597,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 8.31597,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 15.1336,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 15.1336,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 15.1336,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 15.1336,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 21.951,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 21.951,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 21.951,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 21.951,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 28.7686,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 28.7686,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 28.7686,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 28.7686,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 35.586,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 35.586,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 35.586,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 35.586,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 42.4036,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 42.4036,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 42.4036,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 42.4036,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46318,
    cy: 49.221,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6526,
    cy: 49.221,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8421,
    cy: 49.221,
    r: 1.2625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.0315,
    cy: 49.221,
    r: 1.2625,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_22187",
    x1: 22.5811,
    y1: 38.4614,
    x2: 60.9345,
    y2: 38.4522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMission);
export default __webpack_public_path__ + "static/media/Our Mission.5e3ba2cec7028e5601690aec33a1802f.svg";
export { ForwardRef as ReactComponent };